import { render, staticRenderFns } from "./MonthlyIncome.vue?vue&type=template&id=50ba8459&scoped=true&"
import script from "./MonthlyIncome.vue?vue&type=script&lang=js&"
export * from "./MonthlyIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba8459",
  null
  
)

export default component.exports